package br.com.logicalside.proposes.components.sections

import Res
import androidx.compose.runtime.Composable
import br.com.logicalside.proposes.BodyTextStyle
import br.com.logicalside.proposes.Headline4TextStyle
import br.com.logicalside.proposes.components.layouts.InnerContainer
import br.com.logicalside.proposes.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.vars.color.ColorVar
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun ContactSection() {
    InnerContainer(ContactContainerStyle.toModifier().id("contact")) {
        Row(Modifier.displayIfAtLeast(Breakpoint.MD), verticalAlignment = Alignment.CenterVertically) {
            ContactImage()
            ContactContent()
        }

        Column(Modifier.displayUntil(Breakpoint.MD), horizontalAlignment = Alignment.CenterHorizontally) {
            ContactImage()
            ContactContent()
        }
    }
}

@Composable
private fun ContactContent() {
    Column(ContactContentStyle.toModifier()) {
        SpanText(
            Res.string.contact_title,
            Headline4TextStyle.toModifier().then(ContactTitleStyle.toModifier())
        )
        Br()
        Span(BodyTextStyle.toModifier().then(ContactDescriptionStyle.toModifier()).toAttrs()) {
            val sitePalette = ColorMode.current.toSitePalette()
            Text(Res.string.contact_description)

            Link(
                "mailto:proposes@logicalside.com.br",
                "proposes@logicalside.com.br",
                Modifier.setVariable(ColorVar, sitePalette.brand.primary),
                variant = UncoloredLinkVariant
            )
        }
    }
}

@Composable
private fun ContactImage() {
    Image(
        "/contact.png",
        "People using the app",
        ContactImageStyle.toModifier()
    )
}

val ContactContainerStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .padding(topBottom = 6.cssRem, leftRight = 2.cssRem)
}

val ContactContentStyle = CssStyle {
    Breakpoint.MD { Modifier.padding(right = 4.cssRem) }
}

val ContactTitleStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .fontWeight(FontWeight.SemiBold)
            .color(colorMode.toSitePalette().onBackground)
            .textAlign(TextAlign.Center)
    }
    Breakpoint.MD { Modifier.textAlign(TextAlign.Start) }
}

val ContactDescriptionStyle = CssStyle {
    base {
        Modifier
            .color(colorMode.toSitePalette().onBackground)
            .textAlign(TextAlign.Center)
    }
    Breakpoint.MD { Modifier.textAlign(TextAlign.Start) }
}

val ContactImageStyle = CssStyle {
    base { Modifier.height(16.cssRem).display(DisplayStyle.Block).padding(bottom = 2.cssRem) }
    Breakpoint.MD { Modifier.height(18.cssRem).padding(leftRight = 5.cssRem) }
}
